const labels = {
  ajouterTalent: {
    title: "Créer un talent",
    instructions: "Pour créer rapidement le profil de votre talent, ajoutez son CV au format PDF.",
    manualFormNote: "Si vous ne disposez pas d’un fichier CV, vous pouvez aussi remplir manuellement le formulaire.",
    uploadButton: "Ajouter le CV",
    manualButton: "Créer le talent manuellement",
    extractButton: "Extraire les données du CV",
    error: "Vous avez déjà enregistré ces talents.",
    cvAdded: "CV(s) ajouté(s):",
    errorNoCV: "Veuillez ajouter au moins un fichier CV avant de lancer l'extraction.",
    apiError: "Erreur lors de la communication avec l'API.",
    insertError: "Erreur lors de l'insertion du talent",
    extractError: (fileName) => `Erreur lors de l’extraction des données pour le fichier : ${fileName}.`,
    insertMessageError: (message) => `Erreur lors de l'insertion du talent : ${message}`,
    networkInsertError: (error) => `Erreur réseau lors de l'insertion du talent : ${error?.message || 'Erreur inconnue'}`
  },

  accessDenied: {
    title: "Accès refusé",
    message: "Vous n'avez pas les autorisations nécessaires pour accéder à cette page. Veuillez contacter un administrateur.",
    helpButton: "Demander de l'aide"
  },

  pageMaintenance: {
    title: "Page en maintenance",
    message: "Cette page est en cours de développement ou temporairement indisponible.\nMerci de revenir plus tard ou d’explorer les autres fonctionnalités disponibles."
  }
};

export default labels;
